import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Prebuilt Font Awesome CSS — Vite resolves and bundles the bundled webfonts,
// so no manual copying into public/ is needed.
import '@fortawesome/fontawesome-free/css/all.min.css';

/*
  Inter and Orbitron, SELF-HOSTED — the same treatment Font Awesome above
  already gets, and for a stronger reason.

  These used to load from fonts.googleapis.com via a <link> in index.html, with
  no subresource-integrity attribute (Sonar Web:S5725). Adding `integrity` there
  is not an option: the css2 API serves DIFFERENT CSS per User-Agent — measured
  at 16,454 bytes for modern Chrome, 2,312 for old Safari, 2,232 for IE11, so
  three browsers yield three different hashes. Pinning any one of them would
  break the fonts for everyone else. SRI and that endpoint are incompatible by
  construction.

  So the dependency is removed rather than pinned. Serving the fonts from our own
  origin means there is no third-party CDN to compromise, nothing to hash, and no
  request that tells Google the IP of every person who opens a page about a
  landowner's title. Integrity is still guaranteed — by the npm lockfile, which
  is the same promise SRI makes, kept somewhere it can actually hold.

  Variable fonts: one file each spans the whole weight range (Inter 100-900,
  Orbitron 400-900), covering every weight the old link requested.
*/
import '@fontsource-variable/inter';
import '@fontsource-variable/orbitron';

import './scss/index.scss';
import App from './App.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
